import type { EmailTemplate } from "../api/queries/emailTemplateQueries";
import type { TemplateFormData } from "../components/EmailTemplateModal";
import { DEFAULT_INVOICE_LIST_FORMAT } from "./emailTemplatePreview";

export function emailTemplateToFormData(template: EmailTemplate): TemplateFormData {
  return {
    name: template.name,
    subject: template.subject,
    body: template.body,
    trigger_type: template.trigger_type,
    offset_days: template.offset_days,
    condition_balance: template.condition_balance,
    audience_type: template.audience_type ?? "MULTIPLE_INVOICES",
    invoice_list_format:
      template.invoice_list_format ?? DEFAULT_INVOICE_LIST_FORMAT,
    enabled: template.enabled,
    group_ids: template.group_ids ?? [],
    repeat_interval_days: template.repeat_interval_days ?? 5,
    invoice_inclusion_scope: template.invoice_inclusion_scope ?? "OVERDUE_OPEN",
    inclusion_min_days_overdue: template.inclusion_min_days_overdue ?? 90,
  };
}
